var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-text-field',{ref:"field",attrs:{"label":_vm.label,"name":_vm.name},model:{value:(_vm.text),callback:function ($$v) {_vm.text=$$v},expression:"text"}})
}
var staticRenderFns = []

export { render, staticRenderFns }